"use client";

import { Image as ImageType } from "@/types/Image";
import Image from "next/image";
import { useState } from "react";
import AlbumCarouselModal from "../AlbumModal/AlbumCarouselModal";
import "./index.scss";

const ImageGridFilmStrip = ({ images }: { images: ImageType[] }) => {
  const [showAlbumCarouselModal, setShowAlbumCarouselModal] = useState(false);
  const [albumCarouselModalImageIndex, setAlbumCarouselModalImageIndex] =
    useState(0);

  // This component supports only up to 4 images
  images = images.slice(0, 4);

  let sizes: string[];
  if (images.length === 1) {
    sizes = ["100vw"];
  } else if (images.length === 2) {
    sizes = ["50vw", "50vw"];
  } else if (images.length === 3) {
    sizes = [
      "(max-width: 1170px) 33vw, 390px",
      "(max-width: 1170px) 33vw, 390px",
      "(max-width: 1170px) 33vw, 390px",
    ];
  } else {
    sizes = images.map((image) => {
      return "(max-width: 1170px) 25vw, 293px";
    });
  }

  const imageNodes = images.map((image, imageIndex) => {
    return (
      <div
        className={`image-container image-index-${imageIndex}`}
        key={image.src}
      >
        <a
          onClick={() => {
            setAlbumCarouselModalImageIndex(imageIndex);
            setShowAlbumCarouselModal(true);
          }}
        >
          <Image
            src={image.src}
            alt={image.alt}
            fill={true}
            sizes={sizes[imageIndex]}
            style={{ objectFit: "cover" }}
          />
        </a>
      </div>
    );
  });

  return (
    <div className="component image-grid-film-strip">
      <div
        className={`image-grid-film-strip-inner-wrapper number-of-images-${images.length}`}
      >
        {imageNodes}
      </div>
      {showAlbumCarouselModal && (
        <AlbumCarouselModal
          images={images}
          initialImageIndex={albumCarouselModalImageIndex}
          onClose={() => setShowAlbumCarouselModal(false)}
        />
      )}
    </div>
  );
};

export default ImageGridFilmStrip;
